import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import products from '@/components/products'
import aboutUs from '@/components/aboutUs'
import contact from '@/components/contact'
import beddingAndLitterCamas from '@/components/categories/beddingAndLitterCamas'
import naturalHayPasturas from '@/components/categories/naturalHayPasturas'
import naturalMixAves from '@/components/categories/naturalMixAves'
import naturalMixRoedores from '@/components/categories/naturalMixRoedores'
import completeFood from '@/components/categories/completeFood'
import suplementos from '@/components/categories/suplementos'

Vue.use(Router)

export default new Router({
  mode:'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/productos',
      name: 'products',
      component: products
    },
    {
      path: '/nosotros',
      name: 'aboutUs',
      component: aboutUs
    },
    {
      path: '/contacto',
      name: 'contact',
      component: contact
    },
    {
      path: '/bedding-and-litter-camas',
      name: 'beddingAndLitterCamas',
      component: beddingAndLitterCamas
    },
    {
      path: '/natural-hay-pasturas',
      name: 'naturalHayPasturas',
      component: naturalHayPasturas
    },
    {
      path: '/natural-mix-aves',
      name: 'naturalMixAves',
      component: naturalMixAves
    },
    {
      path: '/natural-mix-roedores',
      name: 'naturalMixRoedores',
      component: naturalMixRoedores
    },
    {
      path: '/complete-food',
      name: 'completeFood',
      component: completeFood
    },
    {
      path: '/suplementos',
      name: 'suplementos',
      component: suplementos
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js